import { render, staticRenderFns } from "./FormatReferenceTreeAddFolderDialog.vue?vue&type=template&id=d0aec2de&scoped=true&"
import script from "./FormatReferenceTreeAddFolderDialog.vue?vue&type=script&lang=ts&"
export * from "./FormatReferenceTreeAddFolderDialog.vue?vue&type=script&lang=ts&"
import style0 from "./FormatReferenceTreeAddFolderDialog.vue?vue&type=style&index=0&id=d0aec2de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0aec2de",
  null
  
)

export default component.exports